function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparentHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-1.1 -6.2 375.0 650.6",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(224, 222, 199)"
    },
    original_string_length: 1300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id1476_sf3vcxmj7s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.2,55.1c-4.6,0.7-9.2,1.6-13.8,2.9c-51.1,12.4-90.2,42.8-118,85.8c-18,27.9-30.3,59.5-44.9,89c-1.3-5.6-3.4-13.5-5-21.6 c-8-40.6-14.1-81.6-24.4-121.5c-6.2-24.2-16.7-48.1-29.1-69.9c-13.7-24.2-33.5-26-53.3-6.2c-11.8,12-21.6,25.9-29,41 C5.2,92.4-1.1,133.2,0.2,175.2C3.1,268.8,28.6,357,67.3,441.4c25.8,56.2,55.3,110.8,84.7,169.1c-0.6,8.2-16.6,19.3-3.5,33.9 c3.8-2.8,7-3.9,8-6.1c38-81.8,75.5-163.8,113.8-245.4C307,314.5,341,235,364.8,151.7c6.3-22.2,7.9-46.2,8.5-69.4 S364.6,52.7,341.2,55.1z M357.8,125.3c-15.7,49.2-29.5,99.3-49.6,146.7c-40.4,95.1-84.5,188.7-127.3,282.8 c-4.9,10.8-11.8,20.8-20,35.2c-6.6-8-10-11.2-12.3-15C89.8,475.7,42.7,371.4,20.8,257.5C10.1,201.9,4.8,145.4,23.1,90 c6.6-19.5,15.3-38.3,26-55.9C55.4,23.6,66.9,16.3,76,7.6c21.7,11,29.9,28.7,34.7,46.4c11.8,43.5,22.9,87.2,31,131.5 c9.6,52.7,15.7,106,23.7,159c1,6.6,4,13,6.8,21.6c13.9-10.4,8.7-21.3,7.9-30.5c-3.4-39.7-3.1-79.2,7.6-117.6 c17-60.8,53.4-107.2,109.1-137.5c18.1-9.8,37.2-17.8,59.6-13.6C363.6,86.7,363.8,106.4,357.8,125.3z",
    style: {
      fill: "inherit"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentHeart);
export default __webpack_public_path__ + "static/media/transparentHeart.157cf06537e478a33161b0406b9c04ec.svg";
export { ForwardRef as ReactComponent };